import { Exchange, Operation } from 'urql';
import { pipe, tap } from 'wonka';
import { store } from '../app/store';
import { startLoading, stopLoading } from '../features/loading/loadingSlice';

// Chỉ track queries (GET operations), không track mutations
const isQuery = (operation: Operation): boolean => {
  return operation.kind === 'query';
};

export const loadingExchange: Exchange = ({ forward }) => {
  return (ops$) => {
    // Track operations đang chạy, timeout của chúng và subscription
    const activeOperations = new Map<string, {
      timeoutId: ReturnType<typeof setTimeout>;
      subscription?: any;
    }>();

    return pipe(
      ops$,
      tap((operation: Operation) => {
        // Bắt đầu loading khi query được gửi
        if (isQuery(operation)) {
          const key = `${operation.kind}-${operation.key}`;
          if (!activeOperations.has(key)) {
            // Delay dispatch để tránh cập nhật Redux trong render phase
            setTimeout(() => {
              store.dispatch(startLoading());
            }, 0);

            // Timeout fallback: đảm bảo loading luôn được tắt sau 30s
            const timeoutId = setTimeout(() => {
              if (activeOperations.has(key)) {
                activeOperations.delete(key);
                store.dispatch(stopLoading());
              }
            }, 30000);
            activeOperations.set(key, { timeoutId });
          }
        }
      }),
      forward,
      tap((result) => {
        // Dừng loading khi có result (success hoặc error)
        if (result.operation.kind === 'query') {
          const key = `${result.operation.kind}-${result.operation.key}`;
          const operationData = activeOperations.get(key);
          if (operationData) {
            clearTimeout(operationData.timeoutId);
            activeOperations.delete(key);
            // Delay dispatch để tránh cập nhật Redux trong render phase
            setTimeout(() => {
              store.dispatch(stopLoading());
            }, 0);
          }
        }
      })
    );
  };
};

